import '../store/categories';

/**
 * @ngdoc object
 * @name categories.controller:CategoriesCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.categories')
    .controller('CategoriesDetailsCtrl', [
        'Alert',
        'Category',
        'category',
        'locale',
        '$uibModalInstance',
        '$translate',
        CategoriesDetailsCtrl
    ]);

function CategoriesDetailsCtrl(Alert, Category, category, locale, $uibModalInstance, $translate) {
    var vm = this;

    vm.save = save;
    vm.trash = trash;
    vm.close = close;
    vm.category = category;

    function save() {
        const category = Category.one(vm.category.id);
        category.name = vm.category.name;

        return $uibModalInstance.close(category.put());
    }

    function trash() {
        const translatedValue = (path, params) => {
            return $translate.instant(`categories.controllers.ask_to_delete_category.${path}`, params);
        };

        const promise = Alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {category_name: vm.category.name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
        })
            .then(() => Category.one(category.id).remove());

        $uibModalInstance.close(promise);
    }

    function close() {
        $uibModalInstance.dismiss('close');
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/categories/controllers/categories-details-controller.js